import { testimonials } from '@/mocks/articles';

export default function LatestLeaks() {
  return (
    <section className="bg-background-200/60 py-12 md:py-16">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700">
            吃瓜现场
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-3 leading-tight">
            瓜友辣评
            <br />
            最新爆料热议
          </h2>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 md:gap-5">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="break-inside-avoid mb-4 md:mb-5 bg-background-50 rounded-xl p-5 hover:bg-background-100 transition-colors"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.handle}</p>
                </div>
              </div>
              <blockquote className="text-sm text-foreground-700 leading-relaxed before:content-['\201C'] after:content-['\201D'] before:text-accent-500 after:text-accent-500 before:text-lg after:text-lg">
                {item.quote}
              </blockquote>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}